import { TARIFFS } from '../constants/pagesConstants';
import {
    API_COMMON_URL,
    CHECK_KEY,
    SAVE_KEY,
    SAVE_PRODUCT_ID,
    SET,
    SUCCESS_STATUS,
    USER_INFO,
} from '../constants/constants';
import { sessionKey } from '../selectors/pagesSelectors';
import { productCurrentProductIdSelector } from '../selectors/productSelector';
import { saveCurrencies, savePeriods } from './filtersAction';
import { saveProducts } from './cartAction';
import { FEATURED_PRODUCTS_PAIR } from '../../constants/constants';
import getCurrentQueryParameters from '../../resolvers/getCurrentQueryParameters';
import updateQueryParameters from '../../mutators/updateQueryParameters';
import {
    PROCEED_TO_CHECKOUT_AFTER_AUTH,
    SWITCH_REGISTRATION_FORM_STATE,
    TOGGLE_REGISTRATION_FORM, TOKEN_ERROR_LIST,
} from '../constants/checkoutConstants';
import {logout} from "./authActions";

export const getTariffs = (postData) => (dispatch, getState) => {
    const token = sessionKey(getState());
    const mainProductId = productCurrentProductIdSelector(getState());
    const productsToFetch = [mainProductId, ...FEATURED_PRODUCTS_PAIR[mainProductId]?.products];
    dispatch({
        type: TARIFFS,
        CallAPI: API_COMMON_URL + `?method_name=product_tariffs_get`,
        showTokenError: true,
        postData: {
            ...postData,
            user_token: token,
            product_ids: productsToFetch.join(','),
            currencies: 1,
        },
    }).then((data) => {
        if (data?.apiData?.error_message && TOKEN_ERROR_LIST.includes(data?.apiData?.error_message)) {
            dispatch(logout()).then(() => {
                dispatch(setAccountFormIsVisible(true));
                dispatch(setAccountFormRegisterState(true));
            });
        } else if (data?.apiData?.data?.operation_status === SUCCESS_STATUS) {
            dispatch(saveUserInfo({ ...data?.apiData?.data.user }));
            dispatch(
                savePeriods(
                    Object.values(data.apiData.data?.tariffs).filter((tariff) => !!tariff?.periods),
                    productCurrentProductIdSelector(getState())
                )
            );
            dispatch(saveCurrencies(data.apiData.data?.currencies));
            dispatch(
                saveProducts({
                    products: Object.values(data.apiData.data?.products),
                    id: getState().pages.productId,
                })
            );
        }
    });
};

export const saveUserInfo = (data) => ({
    type: USER_INFO + SET,
    data,
});

export const saveKey = (value) => ({
    type: SAVE_KEY,
    key: value,
});

export const saveProductId = (value) => (dispatch, getState) => {
    dispatch({
        type: SAVE_PRODUCT_ID,
        productId: value,
    }).then(() => {
        const params = getCurrentQueryParameters(getState);
        updateQueryParameters(dispatch, getState, params);
        dispatch(getTariffs());
    });
};

export const checkKey = () => ({
    type: CHECK_KEY,
});

export const setAccountFormIsVisible = (flag) => ({
    type: TOGGLE_REGISTRATION_FORM,
    data: flag
});

export const setProceedToCheckoutAfterAuth = (provider) => ({
    type: PROCEED_TO_CHECKOUT_AFTER_AUTH,
    data: provider
});

export const setAccountFormRegisterState = (flag) => ({
    type: SWITCH_REGISTRATION_FORM_STATE,
    data: flag
});
